import { IonPage, useIonViewWillLeave } from '@ionic/react'
import React from 'react'
import './PatientAllergySearchList.page.css'
import PatientAllergiesSearchListContent from '../patientAllergiesContent/PatientAllergiesSearchListContent.component'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import { useDispatch } from 'react-redux'
import { initializeSearch } from '../../../components/search/store/search.actions'

const PatientAllergiesSearchList: React.FC = () => {
  const dispatch = useDispatch()

  useIonViewWillLeave(() => {
    dispatch(initializeSearch([]))
  })

  return (
    <IonPage id='allergy-search-list'>
      <PCRHeader />
      <PatientAllergiesSearchListContent />
    </IonPage>
  )
}

export default PatientAllergiesSearchList
